import React from 'react';
import { CONTENT_BASE } from '@amzn/ring-common-style-library/lib/colors';
import { translated } from '../../utils/TranslationUtil';

export const MuteIcon: React.FC<{}> = () => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' height='100%' width='100%' fill='none'>
        <title>{translated('Accessibility.SvgTitle.muteIcon')}</title>
        <g id='speaker (e9b3)'>
            <path
                id='^ Name above ^'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.501 21.504H13.497C13.367 21.504 13.249 21.455 13.16 21.374L7.81 16.504H2.5C2.224 16.504 2 16.28 2 16.004V8.00401C2 7.72801 2.224 7.50401 2.5 7.50401H7.81L13.17 2.63401C13.258 2.55701 13.373 2.51001 13.5 2.51001C13.774 2.51001 13.997 2.73101 14 3.00401V21.006C14 21.21 13.878 21.385 13.703 21.463L13.7 21.464C13.643 21.489 13.576 21.504 13.506 21.504H13.5H13.501ZM3.001 15.504H8.005C8.135 15.504 8.253 15.553 8.342 15.634L13.002 19.874V4.13401L8.342 8.37401C8.254 8.45501 8.135 8.50401 8.006 8.50401H3.002L3.001 15.504ZM15.001 14.504C16.382 14.504 17.501 13.385 17.501 12.004C17.501 10.623 16.382 9.50401 15.001 9.50401V8.50401C16.934 8.50401 18.501 10.071 18.501 12.004C18.501 13.937 16.934 15.504 15.001 15.504V14.504ZM15.001 19.004V18.004C18.315 18.004 21.001 15.318 21.001 12.004C21.001 8.69001 18.315 6.00401 15.001 6.00401V5.00401C18.867 5.00401 22.001 8.13801 22.001 12.004C22.001 15.87 18.867 19.004 15.001 19.004Z'
                fill={CONTENT_BASE}
            />
        </g>
    </svg>
);
